import { render, staticRenderFns } from "./StudentAchievmentEdit.vue?vue&type=template&id=5ed8dffc&scoped=true"
import script from "./StudentAchievmentEdit.vue?vue&type=script&lang=js"
export * from "./StudentAchievmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8dffc",
  null
  
)

export default component.exports